import { Step, StepLabel, Stepper } from '@material-ui/core';
import { ReactElement } from 'react';

import './progress-stepper.styles.scss';

export interface IProgressStepperProps {
	activeStep: number;
	labels: string[];
}

export function ProgressStepper(props: IProgressStepperProps): ReactElement {
	const { activeStep, labels } = props;

	return (
		<Stepper
			className="progress-stepper"
			activeStep={activeStep}
			alternativeLabel
		>
			{labels.map((label: string) => (
				<Step key={label}>
					<StepLabel>{label}</StepLabel>
				</Step>
			))}
		</Stepper>
	);
}
